// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1266":"c59e9d3e","1541":"c59e9d3e","2182":"22f42069","7580":"71dd37e3"}[chunkId] + ".chunk.css";
};